import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import PrivacyTipRoundedIcon from "@mui/icons-material/PrivacyTipRounded";
import { Box, Link, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

const links: Array<{
  label: string;
  accessibleLabel: string;
  href: string;
  icon: ReactNode;
}> = [
  {
    label: "Reclamos",
    accessibleLabel: "Abrir Libro de Reclamaciones",
    href: "https://forms.gle/8hNm8dZUCCZX6Tp38",
    icon: <MenuBookRoundedIcon />,
  },
  {
    label: "Reglamento",
    accessibleLabel: "Abrir Reglamento del Estudiante",
    href: "https://drive.google.com/file/d/15dDon5Oohnqtmd0hpUmM9mScOD9r_nq0/view",
    icon: <GavelRoundedIcon />,
  },
  {
    label: "Privacidad",
    accessibleLabel: "Abrir Políticas de Privacidad y Protección de Datos",
    href: "https://drive.google.com/file/d/17Uzx1Nh_U2i08PxE_iI0eHMBsVAkmN4M/view?usp=sharing",
    icon: <PrivacyTipRoundedIcon />,
  },
];

export const Footer: FC = () => (
  <Box
    component="footer"
    aria-label="Información y ayuda"
    sx={{ width: "100%", maxWidth: 760, mt: "auto", pt: 4 }}
  >
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: 1.25,
        pt: 2.5,
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      {links.map((link) => (
        <Link
          key={link.label}
          href={link.href}
          target="_blank"
          rel="noreferrer"
          aria-label={`${link.accessibleLabel} (abre en una pestaña nueva)`}
          underline="none"
          sx={{
            minHeight: 56,
            px: { xs: 0.5, sm: 1.5 },
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            gap: { xs: 0.4, sm: 1.25 },
            color: "#0A229C",
            bgcolor: "rgba(1, 77, 223, 0.045)",
            border: "1px solid rgba(1, 77, 223, 0.12)",
            borderRadius: 2.5,
            transition: "transform 180ms ease, border-color 180ms ease, background 180ms ease",
            "&:hover": {
              bgcolor: "rgba(0, 217, 255, 0.1)",
              borderColor: "rgba(1, 77, 223, 0.28)",
              transform: "translateY(-2px)",
            },
            "&:focus-visible": {
              outline: "3px solid rgba(0, 217, 255, 0.72)",
              outlineOffset: 2,
            },
          }}
        >
          <Box
            aria-hidden="true"
            sx={{
              width: 36,
              height: 36,
              display: "grid",
              placeItems: "center",
              flexShrink: 0,
              color: "primary.main",
              bgcolor: "rgba(1, 77, 223, 0.1)",
              borderRadius: 2,
              "& svg": { fontSize: 19 },
            }}
          >
            {link.icon}
          </Box>
          <Typography sx={{ flex: { sm: 1 }, fontSize: { xs: 10.5, sm: 12.5 }, fontWeight: 700 }}>
            {link.label}
          </Typography>
          <OpenInNewRoundedIcon aria-hidden="true" sx={{ display: { xs: "none", sm: "block" }, fontSize: 15, opacity: 0.6 }} />
        </Link>
      ))}
    </Box>
  </Box>
);
